import { loadable } from '@namespace/common';

export default loadable(() => import('./CookieManagement'));
